import { useEffect, useState } from "react";
import MinimalArrow from "../components/MinimalArrow";
import services from '../assets/json/services.json';
import servizi1 from '../assets/Servizi/unnamed.jpg';
import quadricipideImage from '../assets/Servizi/player.webp';
import ContactForm from "../components/contactForm/ContactForm";



export default function Servizi() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fadeOut, setFadeOut] = useState(false);

    const imgServizi = [servizi1]

    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])

    // useEffect(() => {
    //   const interval = setInterval(() => {
    //     setFadeOut(true); 
    //     setTimeout(() => {
    //       setCurrentIndex((prevIndex) => (prevIndex + 1) % imgServizi.length); 
    //       setFadeOut(false);
    //     }, 1000);
    //   }, 5000);
  
    //   return () => clearInterval(interval); 
    // }, [imgServizi.length]);


return <>
    <MinimalArrow 
        title={'Psicologia dello sport'}
        subtitle={"Supporto psicologico personalizzato per affrontare sfide emotive, motivazionali e mentali durante la carriera sportiva."}
        backgroundImage={quadricipideImage}
    />
    <div className="flex bg-black">
        <div className="w-2/5 h-screen sticky top-0 overflow-hidden hidden md:block">
            <img src={imgServizi[0]}  alt="" className={`object-cover w-full h-full transition-opacity duration-1000 ease-in-out ${
            fadeOut ? 'opacity-0' : 'opacity-100'
            }`} />
        </div>
        <div className="md:w-3/5 w-full relative flex flex-col items-center overflow-auto">
            <h2 className="text-4xl text-white font-semibold pt-12 text-mcare  panoragraf-light">SERVIZI</h2>            
            <div className="w-full h-full inset-0 ">
                <div className="relative text-white h-full pt-5 text-center flex flex-col items-center bg-black">
                    <ul className='text-left mb-8 w-full max-w-2xl px-5'>
                        <h3 className="text-2xl text-white font-semibold pt-12 text-mcare  panoragraf-light">PSICOLOGIA DELLO SPORT</h3>
                        <p className="text-white pt-5">La carriera sportiva è un percorso ricco di emozioni, sfide e momenti cruciali che richiedono non solo abilità fisiche, ma anche una forte resilienza mentale. Il nostro servizio di supporto psicologico è studiato per fornire agli atleti strumenti personalizzati per affrontare ogni aspetto della performance, dalla gestione dello stress alla ripresa post-infortunio. Attraverso colloqui individuali, programmi di mental training specifici, assessment psicologici e tecniche avanzate di rilassamento, aiutiamo gli atleti a sviluppare una mentalità vincente, a superare ostacoli emotivi e a ritrovare la motivazione necessaria per eccellere nel loro sport.</p>
                        {Array.isArray(services) && services.map((service, index) => {
                            const serviceItems = service.services || [service];

                            return serviceItems.map((item, itemIndex) => (
                                <li key={itemIndex} className="mb-5 pb-3 mt-8">
                                    <span className="text-2xl font-semibold">{item.name}:</span>
                                    <p className="pt-5">{item.description}</p>
                                    {item.listDesc && Array.isArray(item.listDesc) && item.listDesc.length > 0 && (
                                        <ul className="">
                                            {item.listDesc.map((listItem, listIndex) => (
                                                <li key={listIndex} className="pt-2">
                                                    <b>{listItem.title}:</b> {listItem.desc}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </li>
                            ));
                        })}
                    </ul>
                </div>
            </div>
        </div>
    </div>
    
        {/* sez. convenzioni */}
        <div className="grid grid-cols-4 gap-0" id='formContatti'>
            <div className="col-span-4 flex justify-center items-center py-32 bg-black">
            <div className="w-full absolute z-0" style={{"height":"120%"}}></div>
            <div className='w-full lg:w-2/6 z-30 px-5'>
                <p className='text-center text-4xl font-semibold text-mcare panoragraf-light'>Prenota una visita</p>
                <ContactForm 
                LandingName='mcare'
                Name={true}
                NameClass='text-white'
                NameText='Nome e Cognome:'
                NameRequired={true}
                Tel={true}
                TelClass='text-white'
                TelText='Telefono:'
                TelRequired={true}
                Email={true}
                EmailClass='text-white'
                EmailText='Email:'
                EmailRequired={true}
                ConsensoDati={true}
                ConsensoDatiRequired={true}
                ConsensoDatiText='Consenso dati'
                ConsensoDatiID={1}
                ConsensoDatiClass='text-white'
                successText='Messaggio inviato con successo!'  
                successLink='/'
                errorText='Si è verificato un errore, Riprova!'
                SendText='Invia'
                SendClass='progress-button-mcare w-full'
                borderType="border bg-[#65806e69]"
                />
            </div>
            </div>
        </div>
</>
}